import { createBrowserHistory } from 'history';
import config from 'config';
import { store } from 'ducks';
import initGa from './ga';

const history = createBrowserHistory({
  basename: config.basename,
});

export const historyPush = (originalPath, props) => {
  const unsubscribe = store.subscribe(() => {});
  const {
    ui: { brand },
  } = store.getState();
  let path = originalPath;
  if (brand) {
    path = `/${brand}${originalPath}`;
  }
  history.push(path, props);
  unsubscribe();
};

initGa(history);

export default history;
